<div class="time-off-event-detail">
  <div class="dialog-header">
    <div class="dialog-title-row">
      <mat-icon class="title-icon">event</mat-icon>
      <h2 class="dialog-title">Time Off Details</h2>
    </div>
    <button mat-icon-button disableRipple (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-body">
    <!-- Employee name + status row -->
    <div class="employee-header">
      <div class="employee-info">
        <div class="employee-avatar">
          {{ data.firstName.charAt(0) }}{{ data.lastName.charAt(0) }}
        </div>
        <div class="employee-name-block">
          <a class="employee-name resource-link"
             [routerLink]="['/resources', data.employeeId]"
             (click)="dialogRef.close()">
            {{ data.fullName }}
          </a>
          @if (employeeMeta) {
            <span class="employee-meta">{{ employeeMeta }}</span>
          }
        </div>
      </div>
      <span class="status-badge" [attr.data-status]="data.statusCode">
        {{ data.statusName }}
      </span>
    </div>

    <!-- Date range card -->
    <div class="date-card">
      <div class="date-block">
        <span class="date-label">From</span>
        <span class="date-value">{{ formatDate(data.startDate) }}</span>
      </div>
      <div class="date-divider">
        <mat-icon>arrow_forward</mat-icon>
      </div>
      <div class="date-block">
        <span class="date-label">To</span>
        <span class="date-value">{{ formatDate(data.endDate) }}</span>
      </div>
    </div>

    <!-- Duration + type -->
    <div class="duration-row">
      <div class="duration-info">
        <mat-icon class="duration-icon">schedule</mat-icon>
        <span class="duration-text">
          {{ data.daysOff }} {{ data.daysOff === 1 ? 'day' : 'days' }}
        </span>
      </div>
      @if (data.typeName) {
        <span class="type-name-chip">{{ data.typeName }}</span>
      }
    </div>

    <!-- Carry-over designation (PBI 5770 AC#3); renders nothing without carry-over -->
    <app-time-off-carry-over-summary
      [carryOverDays]="data.carryOverDays"
      [daysOff]="data.daysOff"
    />
  </div>
</div>
